import React from 'react'
import { Classroom as ClassroomConstants } from '@constants'
import { Text, Button } from '@components/UI'

import { useSketchpadStateDispatch } from '../hooks'

const Onboarding = () => {
  const dispatch = useSketchpadStateDispatch()
  return (
    <div className='gp-ClassroomOnboarding'>
      <div className='gp-ClassroomOnboarding-wrapper'>
        <div className='gp-ClassroomOnboarding-intro gp-ClassroomOnboarding-step'>
          <Text style={{ fontSize: 72 }}>👋</Text>
          <Text className='text-l' style={{ marginTop: 8 }}>
            Start sketching for your session
          </Text>
          <Text className='text-e' style={{ opacity: 0.45, marginTop: 4 }}>
            You can use your touchscreen device to draw in sketch files
          </Text>
        </div>
        <Button
          className='gp-ClassroomOnboarding-nextButton'
          theme='c interactive'
          inverted
          group='a4'
          icon={{
            name: 'arrow right long',
            value: 'Connect',
            group: 'a3'
          }}
          events={{
            onClick: () =>
              dispatch({
                type: 'set_step',
                payload: ClassroomConstants.STEPS.READY
              })
          }}
        />
      </div>
    </div>
  )
}

export default Onboarding
